import { ButtonHTMLAttributes, MouseEvent, useCallback } from 'react'
import { X } from 'lucide-react'
import { twMerge } from 'tailwind-merge'
import { useToastContext } from './context'

interface ToastCloseProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string
  onDismiss?: () => void
}

export function ToastClose({ className, children, onClick, onDismiss, ...props }: ToastCloseProps) {
  const toastContext = useToastContext()

  const handleClick = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation()

      if (onClick) {
        onClick(event)
      } else {
        toastContext?.close()
      }

      onDismiss?.()
    },
    [onClick, toastContext, onDismiss],
  )

  return (
    <button
      className={twMerge(
        'bg-background text-foreground absolute -left-2 -top-2 flex size-6 items-center justify-center rounded-full opacity-0 transition-opacity',
        'after:absolute after:inset-[-8px] after:rounded-full after:content-[""]',
        'group-hover:opacity-80',
        'hover:bg-background hover:opacity-100',
        className,
      )}
      aria-label="Close"
      onClick={handleClick}
      {...props}
    >
      {children || <X className="size-4" />}
    </button>
  )
}
